import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["method"]

  set({ currentTarget }) {
    this.methodTarget.value = currentTarget.dataset.method
  }
}
